import { render, staticRenderFns } from "./StatementAdd.vue?vue&type=template&id=ccc1121e&"
import script from "./StatementAdd.vue?vue&type=script&lang=js&"
export * from "./StatementAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports